// RolePermissions.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Button,
} from '@mui/material';

const RolePermissions = () => {
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    const response = await axios.get('/api/roles-permissions');
    setRoles(response.data.roles);
    setPermissions(response.data.permissions);
  };

  const handlePermissionChange = (roleId, page) => {
    setPermissions((prev) => ({
      ...prev,
      [roleId]: {
        ...prev[roleId],
        [page]: !prev[roleId][page],
      },
    }));
  };

  const savePermissions = async () => {
    await axios.post('/api/update-role-permissions', { permissions });
    alert('تم حفظ التغييرات بنجاح');
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>اسم الصفحة</TableCell>
            {roles.map((role) => (
              <TableCell key={role.role_id} align="center">
                {role.role_name_ar}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {['horse-list', 'horse-edit', 'user-list', 'dashboard'].map(
            (page) => (
              <TableRow key={page}>
                <TableCell>{page}</TableCell>
                {roles.map((role) => (
                  <TableCell key={role.role_id} align="center">
                    <Checkbox
                      checked={permissions[role.role_id]?.[page] || false}
                      onChange={() =>
                        handlePermissionChange(role.role_id, page)
                      }
                    />
                  </TableCell>
                ))}
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
      <Button variant="contained" onClick={savePermissions} sx={{ m: 2 }}>
        حفظ الصلاحيات
      </Button>
    </TableContainer>
  );
};

export default RolePermissions;
